import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Alert, Button, Stack, Typography } from '@mui/material';
import {
  Control,
  FieldArrayWithId,
  FieldErrors,
  UseFieldArrayRemove,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { ProductDto } from 'desk-common';
import { FormValues } from './constants/orderForm.constants';
import { OrderItemRow } from './OrderItemRow';

interface Props {
  fields: FieldArrayWithId<FormValues, 'items', 'id'>[];
  items: FormValues['items'];
  itemsAlert: string | null;
  control: Control<FormValues>;
  register: UseFormRegister<FormValues>;
  setValue: UseFormSetValue<FormValues>;
  errors: FieldErrors<FormValues>;
  products: ProductDto[];
  selectedProductIds: number[];
  isReadOnly: boolean;
  isEditable: boolean;
  remove: UseFieldArrayRemove;
  onAppendItem: () => void;
  onClearItems: () => void;
}

export function OrderItemsList({
  fields,
  items,
  itemsAlert,
  control,
  register,
  setValue,
  errors,
  products,
  selectedProductIds,
  isReadOnly,
  isEditable,
  remove,
  onAppendItem,
  onClearItems,
}: Props) {
  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1" fontWeight={600}>
        Productos
      </Typography>

      {itemsAlert && <Alert severity="warning">{itemsAlert}</Alert>}

      {fields.map((field, index) => (
        <OrderItemRow
          key={field.id}
          index={index}
          control={control}
          register={register}
          setValue={setValue}
          errors={errors}
          products={products}
          items={items}
          selectedProductIds={selectedProductIds}
          isReadOnly={isReadOnly}
          isEditable={isEditable}
          remove={remove}
        />
      ))}

      {isEditable && (
        <Stack direction="row" spacing={2}>
          <Button startIcon={<AddIcon />} onClick={onAppendItem}>
            Agregar producto
          </Button>

          <Button startIcon={<DeleteIcon />} onClick={onClearItems}>
            Limpiar Todo
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
